import { Questionnaire, UserAnswer } from '@lib/types';
import { createAction, props } from '@ngrx/store';

export const loadQuestionnaire = createAction(
  '[Feedback] Load Questionnaire',
  props<{ restaurantId: number, reservationId?: string, customerId?: string }>()
);

export const loadQuestionnaireSuccess = createAction(
  '[Feedback] Load Questionnaire Success',
  props<{ questionnaire: Questionnaire }>()
);

export const loadQuestionnaireFailure = createAction(
  '[Feedback] Load Questionnaire Failure',
  props<{ error: any }>()
);

export const submitQuestionnaire = createAction(
  '[Feedback] Submit Questionnaire',
  props<{ questionnaire: { restaurantId: number, answers: UserAnswer[], reservationId?: string, customerId?: string, language?: string, metaData?: string } }>()
);

export const submitQuestionnaireSuccess = createAction(
  '[Feedback] Submit Questionnaire Success',
  props<{ averageRatting: number, submissionId: number }>()
);

export const submitQuestionnaireFailure = createAction(
  '[Feedback] Submit Questionnaire Failure',
  props<{ error: any }>()
);

export const submitLinkAction = createAction(
  '[Feedback] Submit Link Action',
  props<{ linkAction: { restaurantId: number, link: string, submissionId: string } }>()
);

export const submitLinkActionSuccess = createAction(
  '[Feedback] Submit Link Action Success',
  props<{ success: boolean }>()
);

export const submitLinkActionFailure = createAction(
  '[Feedback] Submit Link Action Failure',
  props<{ error: any }>()
);
